window.isDevEnvironment = function () {
  let environment = document.body.dataset.environment;

  if (environment && environment == 'development') {
    return true;
  }

  return false;
}